<template>
  <v-flex xs12 class="chapter" v-if="chapterList.length > 0">
    <v-card class="panelBlock region-widget">
      <v-flex tag="h2">{{
        communityCommonConstant.regionChapters.Title
      }}</v-flex>
      <v-tabs
        v-model="currentTab"
        slider-color="ypo_blue"
        class="region-widget__tabs"
      >
        <v-tab
          v-for="(item, index) in items"
          :key="index"
          :data-qe-id="`chapter-type_${index}`"
          @click="getChapterListbyType(item.value)"
        >
          {{ item.key }}
        </v-tab>
        <v-tab-item v-for="(list, i) in chapterFilterListbyType" :key="i">
          <v-flex>
            <div @click="openCommunity(list.communityId)" :data-qe-id="`chapter-list_${i}`" class="region-widget__chapter-name">
              {{ list.name }}
            </div>
          </v-flex>
        </v-tab-item>
      </v-tabs>
      <v-flex text-xs-center pa-5 v-if="chapterFilterListbyType.length === 0">
        <span>{{ communityCommonConstant.regionChapters.NO_Chapters }}</span>
      </v-flex>
    </v-card>
  </v-flex>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { communityCommonConstant, getParentOrCommunityId } from "../ChapterPage/communityCommon.constant";
import { storeAction } from "../../store/storeActions.constant";
import { storeGetters } from "../../store/storeGetters.constant";
import { getHbRedirectByCommunityId } from "@/common/utils/hivebriteUtils";

export default {
  name: "ChapterList",
  created() {
    this.getChapterData();
    this.$watch(
      () => this.$store.getters[storeGetters.communityIdPromise],
      () => {
        this.getChapterData();
      },
    );
  },
  data: () => {
    return {
      currentTab: 1,
      chapterType: communityCommonConstant.regionChapters.YPO_Chapter,
      communityCommonConstant,
      items: [
        { key: "All", value: communityCommonConstant.regionChapters.ALL },
        { key: "YPO", value: communityCommonConstant.regionChapters.YPO_Chapter },
        { key: "YPO Gold", value: communityCommonConstant.regionChapters.YPO_Gold_Chapter },
      ],
    };
  },
  methods: {
    ...mapActions({
      getChapterList: `chapter/${storeAction.getChapterList}`,
    }),
    getChapterData() {
        this.getChapterList(this.communityId).then(()=> {})
    },
    getChapterListbyType(value) {
      this.chapterType = value;
    },
    openCommunity(communityId) {
      const hbRedirectCommunity = getHbRedirectByCommunityId(this.connectPlusRedirects, communityId);
      if (hbRedirectCommunity) {
        window.open(hbRedirectCommunity.redirectUrl, '_self');
      } else {
        this.$router.push(`/chapter/${communityId}`);
      }
    },
  },
  computed: {
    ...mapGetters({
      allChapterList: `chapter/${storeGetters.allChapterList}`,
      chapterList: `chapter/${storeGetters.chapterList}`,
      isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
      connectPlusRedirects: `connectPlus/${storeGetters.connectPlusRedirects}`,
    }),
    chapterFilterListbyType() {
      if (this.chapterType !== communityCommonConstant.regionChapters.ALL) {
        return this.chapterList.filter(item => item.ypoIType === this.chapterType);
      }  
        return this.chapterList;
    },
    communityId(){
      return getParentOrCommunityId(this.allChapterList, this.$route.params.communityId);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../common/styles/_colors.scss";

.region-widget {
  a {
    color: $ypo-dark-gray;
    display: inline-block;
    margin: 20px 0 0 20px;
    cursor: pointer;
    text-decoration: none;

    &:hover {
      color: $ypo_blue;
      text-decoration: underline;
    }
  }

  &__chapter-name {
    cursor: pointer;
    color: $ypo-dark-gray;
    padding: 10px 5px;
    &:hover {
      text-decoration: underline;
    }
  }
}

.map-widget {
  .googleMap {
    min-height: 250px;
  }
}</style
><style lang="scss">
@import "../../common/styles/_colors.scss";

.region-widget {
  .v-tabs__bar {
    background-color: $ypo-light-gray-background;
  }

  .v-tabs__container {
    height: 40px;
  }

  .v-tabs__div {
    width: 33%;
    border-right: 1px solid $ypo-medium-gray;

    a {
      font-weight: 600;
      color: $ypo-blue;
      opacity: 0.5;

      &.v-tabs__item--active {
        opacity: 1;
      }
    }

    &:last-child {
      border-right: none;
    }
  }

  .v-window__container {
    max-height: 250px;
    overflow-y: auto;
    min-height: 250px;
  }

  .v-window-item {
    max-height: 250px;
    overflow-y: auto;
    margin: 5px;
    display: block !important;
  }
}
</style>